import { render, staticRenderFns } from "./ims_list.vue?vue&type=template&id=0e571889&scoped=true"
import script from "./ims_list.vue?vue&type=script&lang=js"
export * from "./ims_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e571889",
  null
  
)

export default component.exports